export enum AccessTypes {
  All = 'All',
  Selected = 'Selected',
  OnlyMe = 'OnlyMe',
  AllowSelected = 'AllowSelected',
  BlockSelected = 'BlockSelected',
}

export enum SelectedUsersTypes {
  Allow = 'Allow',
  Block = 'Block',
}

export enum Crud {
  CREATE = 'c',
  READ = 'r',
  UPDATE = 'u',
  DELETE = 'd',
}

export enum AccessSubjectTypes {
  User = 'User',
  ApiKey = 'ApiKey',
}

export type TAccessRights = {
  [Crud.CREATE]: boolean;
  [Crud.READ]: boolean;
  [Crud.UPDATE]: boolean;
  [Crud.DELETE]: boolean;
};
